import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Small inline badge used to clearly flag that ratings/reviews shown on
 * public profile pages are illustrative placeholder data, since the real
 * reviews backend has not been built yet. Must accompany every mock
 * rating/review value so visitors are never misled into thinking this is
 * genuine customer feedback.
 */
const SampleDataBadge: React.FC = () => (
  <Tooltip title="Ratings & reviews shown here are sample placeholder data for preview purposes only - not real customer feedback.">
    <Chip
      icon={<InfoOutlinedIcon sx={{ fontSize: 16 }} />}
      label="Sample data"
      size="small"
      sx={{
        bgcolor: 'rgba(255,255,255,0.08)',
        color: 'rgba(255,255,255,0.7)',
        fontStyle: 'italic',
        '& .MuiChip-icon': { color: 'rgba(255,255,255,0.5)' },
      }}
    />
  </Tooltip>
);

export default SampleDataBadge;
